<div class="bg-blue-2 d-flex al-center sp-between p-4">
  <div>
    <div>
      <span class="text-white fw-extrabold fs-4">Producto de interés</span>
    </div>
    <div>
      <span class="text-white fs-6 fw-regular">Asigna productos de posible interés a tus clientes</span>
    </div>
  </div>
  <div>
    <img src="assets/svg/Icon_close.svg" mat-dialog-close alt="">
  </div>
</div>
<mat-dialog-content class="p-5 d-flex flex-column content-form">
  <div>
    <span class="fs-5 fw-bold">Productos</span>
  </div>
  <div class="mb-3">
    <span class="fs-6 fw-regular">Busca los productos de posible interés y añádelos a la lista de tu cliente.</span>
  </div>
  <div class="d-flex flex-column">
    <!-- <label nz-checkbox [ngModel]="in.checked" [ngModelOptions]="{standalone: true}" (ngModelChange)="in.checked = !in.checked">{{in.descripcion}}</label> -->
    <label nz-checkbox *ngFor="let product of productList" class="fs-6 fw-bold text-blue-2 mx-0 mb-2" [ngModel]="product.checked" 
    (ngModelChange)="product.checked = !product.checked" >
      {{product.titulo}}</label>
  </div>
</mat-dialog-content>
<div class="p-4 text-end content-action">
  <mat-dialog-actions align="end">
    <button mat-flat-button al class="bg-blue-2" (click)="asignProducts()">
      <span class="fw-bold fs-5 text-white me-3">Asignar productos</span>
      <img src="assets/svg/Icon_arrow_right_white.svg" alt="">
    </button>
  </mat-dialog-actions>
</div>
<ng-container *ngIf="loader">
  <app-loader></app-loader>
</ng-container>